import { IBreadcrumbItem, PanelType } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import {
  IconButton,
  iconButtonStylesNoBG,
  IPageHeaderProps,
  IPanelProps,
  PageHeader,
  pageHeaderStylesSecondary,
  Panel,
  useClassNames,
} from '@h2oai/ui-kit';
import { useEffect } from 'react';

import { ScheduledTask } from '../../featurestore/gen/ai/h2o/featurestore/api/v1/CoreService.pb';
import { ContentsTitle, defaultPanelWidth } from '../../featurestore/models';
import { Schedule } from '../Schedule/Schedule';
import { ISchedulePanelClassNames, ISchedulePanelStyles, schedulePanelStylesDefault } from './SchedulePanel.styles';

const getBreadcrumbItems = (name: string, task?: ScheduledTask): IBreadcrumbItem[] => {
  return [
    ...(name ? [{ text: `${ContentsTitle.featureSet}: ${name}`, key: `${ContentsTitle.featureSet} ${name}` }] : []),
    {
      text: `${task ? 'Edit ' : ''}${ContentsTitle.schedule}`,
      key: ContentsTitle.schedule,
      isCurrentItem: true,
    },
  ];
};

interface ISchedulePanelProps {
  featureSetName?: string;
  featureSetVersion?: string;
  featureSetId?: string;
  projectId?: string;
  task?: ScheduledTask;
  show: boolean;
  onDismiss: (ev?: KeyboardEvent | React.SyntheticEvent<HTMLElement, Event> | undefined, task?: ScheduledTask) => void;
}

export const SchedulePanel = ({
  featureSetName = '',
  featureSetId,
  featureSetVersion,
  projectId,
  task,
  show,
  onDismiss,
}: ISchedulePanelProps) => {
  const [isOpen, { setTrue: open, setFalse: close }] = useBoolean(false);
  const panelProps: IPanelProps = {
    type: PanelType.custom,
    customWidth: defaultPanelWidth,
    isOpen,
    onDismiss,
    isFooterAtBottom: true,
    hasCloseButton: false,
  };

  const pageHeaderProps: IPageHeaderProps = {
    pageTitle: ContentsTitle.schedule,
    styles: pageHeaderStylesSecondary,
    breadcrumbProps: {
      items: getBreadcrumbItems(featureSetName, task),
    },
    actions: <IconButton styles={iconButtonStylesNoBG} iconName="Clear" onClick={() => onDismiss()} />,
  };

  useEffect(() => {
    if (show) {
      open();
    } else {
      close();
    }
  }, [show]);
  const classNames = useClassNames<ISchedulePanelStyles, ISchedulePanelClassNames>(
    'SchedulePanel',
    schedulePanelStylesDefault
  );
  return (
    <Panel {...panelProps}>
      <div className={classNames.root}>
        <PageHeader {...pageHeaderProps} />
        <Schedule
          featureSetVersion={featureSetVersion}
          featureSetId={featureSetId}
          projectId={projectId}
          task={task}
          onSave={(newTask) => onDismiss(undefined, newTask)}
          onCancel={onDismiss}
        />
      </div>
    </Panel>
  );
};
